class KabilaConfig {
    static isProd = true;
    static BASE_URL_PROD = "https://kabila.store";
    static BASE_URL_DEV = "http://localhost:3011";

    static config = {
        BASE_URL: this.isProd ? this.BASE_URL_PROD : this.BASE_URL_DEV,
        FEATURE: {
            RECENT_ORDERS_SECTION: {
                enabled: true
            }
        }
    }

    static getBaseUrl() {
        return this.config.BASE_URL;
    }

    static getFeatureConfig(feature) {
        return this.config.FEATURE[feature];
    }

    static isRecentOrdersSectionEnabled() {
        return this.getFeatureConfig('RECENT_ORDERS_SECTION').enabled;
    }
}